<!-- 分页加载PDF，开始加载4页，滚动时动态加载 -->
<template>
  <div class="vue-pdf-wrap">
    <div class="pageInfo">
      <span class="fileName">{{ fileName }}</span>
      <div class="pageCount">
        <span class="pageNumber">{{ nextShowPage }}</span>
        <span class="otherSpan">/{{ numPages }}页</span>
      </div>
    </div>
    <div class="pdf-detail" id="pdfDetail">
      <!-- <div style="position:absolute;bottom: 0.26rem;right: 0.26rem;font-size: 0.13rem;">{{nextShowPage+"/"+numPages}}</div> -->
      <div class="pdf-canvas-wraper" :id="canvasId" ref="pdfcanvas" style="height: 100%; overflow-y: scroll"></div>
    </div>
    <div class="pdfFooter">
      <div @click="closePdf" class="closeBtn">关闭</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "vue-pdf",
  props: ["pdfurl", "fileName"],
  data () {
    return {
      isLargePdf: false,
      pageNumber: 1,
      numPages: 0,
      pdf: "",
      lastPreShowPage: 1,
      lastNextShowPage: 1,
      preShowPage: 0,
      nextShowPage: 0,
      showPageNum: 2,
      dataId: 0,
      cleanTimer: "",
      isUp: false,
      isRender: false,
      removeCount: 0,
      renderTimer: undefined
    };
  },
  mounted () {
    this.addScrollListener();
    this.$nextTick(() => {
      this.$store.commit(this.$types.UPDATE_LOADING, true);
      this.getPdf();
    });
  },
  watch: {
    pdfurl () {
      this.cleanCanvas();
      this.initPdf();
    }
  },
  computed: {
    canvasId () {
      return "pdfcanvas_" + Math.random();
    }
  },
  methods: {
    initPdf () {
      this.addScrollListener();
      this.$nextTick(() => {
        this.$store.commit(this.$types.UPLOAD_LOADING,"正在加载pdf文件, 请稍候...");
        this.getPdf();
      });
    },
    //限流
    throttle (func, delay) {
      let timer = null;
      let lastTime = 0;
      return function () {
        const now = new Date().getTime();
        if (now - lastTime >= delay) {
          func.apply(this, arguments);
          lastTime = now;
        } else {
          clearTimeout(timer);
          timer = setTimeout(() => {
            func.apply(this, arguments);
          }, delay - (now - lastTime));
        }
      };
    },
    dealScrollEvent (that, e, container) {
      //计算上一页的位置
      var canvasDoms = document.getElementsByTagName("canvas");
      for (let i = 0; i < canvasDoms.length; i++) {
        let canvasItem = canvasDoms[i];
        var rect = canvasItem.getBoundingClientRect();
        //console.log(rect);
        if (rect.top >= -rect.height && rect.bottom <= rect.height) {
          //console.log("显示：" + canvasItem.getAttribute("dataId"));
          that.preShowPage = Number(canvasItem.getAttribute("dataId"));
        }
        if ((rect.top < e.target.clientHeight / 2 && rect.top > 0) || (rect.bottom > e.target.clientHeight / 2 && rect.bottom < e.target.clientHeight)) {
          that.nextShowPage = Number(canvasItem.getAttribute("dataId"));
        }
      }
      if (that.preShowPage < 1) {
        that.preShowPage = 1;
      }
      if (that.preShowPage > that.numPages) {
        that.preShowPage = that.numPages;
      }
      if (that.nextShowPage < 1) {
        that.nextShowPage = 1;
      }
      if (that.nextShowPage > that.numPages) {
        that.nextShowPage = that.numPages;
      }
      //向下翻滚时，动态加载新的canvas并渲染下一页PDF内容
      if (that.isRender) {
        return;
      }
      if (
        (that.preShowPage == that.lastPreShowPage + 1 && that.preShowPage > that.lastPreShowPage && that.preShowPage >= 2 && that.preShowPage < that.numPages - 1) ||
        (e.target.scrollTop + e.target.clientHeight + 50 > e.target.scrollHeight && that.preShowPage < that.numPages)
      ) {
        that.isUp = false;
        that.dataId = Number(container.lastElementChild.attributes.dataId.value) + 1;
        if (that.dataId > that.numPages) {
          return;
        }
        let canvas = document.createElement("canvas");
        that.renderPDF(canvas, that.dataId, container);
        //向上翻滚时，动态加载新的canvas并渲染上一页PDF内容
      } else if (
        (that.preShowPage == that.lastPreShowPage - 1 && that.preShowPage < that.lastPreShowPage && that.preShowPage <= that.numPages - 2 && that.removeCount > 0) ||
        (e.target.scrollTop <= 50 && that.preShowPage > 1)
      ) {
        that.isUp = true;
        that.dataId = Number(container.firstElementChild.attributes.dataId.value) - 1;
        if (that.dataId <= 0) {
          return;
        }
        let canvas = document.createElement("canvas");
        that.renderPDF(canvas, that.dataId, container);
      }
      that.lastPreShowPage = that.preShowPage;
      that.lastNextShowPage = that.nextShowPage;
    },
    addScrollListener () {
      let that = this;
      let container = document.getElementById(that.canvasId);
      container.onscroll = e => {
        //console.log("scroll: "+that.isRender)
        if (!that.pdf || !e.target.firstElementChild) {
          return;
        }
        that.throttle(that.dealScrollEvent(that, e, container), 200);
      };
    },
    getPage (pdf, pageNumber, container, numPages) {
      //获取pdf
      let _this = this;
      pdf.getPage(pageNumber).then(page => {
        let scale = container && container.offsetWidth / page.view[2];
        let viewport = page.getViewport(scale);
        let canvas = document.createElement("canvas");
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        canvas.setAttribute("dataId", ++_this.dataId);
        container.appendChild(canvas);
        let ctx = canvas.getContext("2d");
        var renderContext = {
          canvasContext: ctx,
          transform: [1, 0, 0, 1, 0, 0],
          viewport: viewport,
          intent: "print"
        };
        page.render(renderContext).then(() => {
          console.log("PDF显示成功");
          this.$store.commit(this.$types.UPDATE_LOADING, false);

          // if (_this.isInit) {
          //   //修复第一次渲染不完整，再次渲染一次
          //   _this.isInit = false;
          //   //重置id，修复超过4页时，第五页渲染错误为第六页
          //   _this.dataId = 0;
          //   canvas.setAttribute("dataId", _this.dataId);
          //   container.removeChild(canvas);
          //   _this.getPage(pdf, 1, container, numPages);
          //   return;
          // }
          pageNumber += 1;

          if (pageNumber <= 4 && pageNumber <= numPages) {
            _this.getPage(pdf, pageNumber, container, numPages);
          } else {
            pdf.cleanup();
            this.$store.commit(this.$types.UPDATE_LOADING, false);
            _this.$emit("pdfDone", _this.$el.scrollHeight);
          }
        });
      });
    },
    renderPDF (canvas, dataId, container) {
      let that = this;
      if (canvas) {
        that.isRender = true;
        if (!that.renderTimer) {
          that.renderTimer = setTimeout(() => {
            clearTimeout(that.renderTimer);
            that.renderTimer = undefined;
            if (that.isRender) {
              console.log("表单加载超时，请重新打开");
              alert("表单加载超时，请重新打开");
            }
          }, 10000);
        }
        console.log("start getPDFPage" + that.dataId);
        that.pdf.getPage(dataId).then(page => {
          let scale = container && container.offsetWidth / page.view[2];
          let viewport = page.getViewport(scale);
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          canvas.setAttribute("dataId", dataId);
          let ctx = canvas.getContext("2d");
          var renderContext = {
            canvasContext: ctx,
            transform: [1, 0, 0, 1, 0, 0],
            viewport: viewport,
            intent: "print"
          };
          console.log("start renderPDF" + that.dataId);
          page.render(renderContext).promise.then(
            () => {
              if (that.renderTimer) {
                clearTimeout(that.renderTimer);
                that.renderTimer = undefined;
              }
              console.log("renderPDF" + that.dataId);
              if (!that.isUp) {
                let firstCanvas = container.firstElementChild;
                firstCanvas.getContext("2d").clearRect(0, 0, firstCanvas.width, firstCanvas.height);
                firstCanvas.width = 0;
                firstCanvas.height = 0;
                container.removeChild(firstCanvas);
                that.removeCount++;
                container.appendChild(canvas, dataId);
              } else {
                let lastCanvas = container.lastElementChild;
                lastCanvas.getContext("2d").clearRect(0, 0, lastCanvas.width, lastCanvas.height);
                lastCanvas.width = 0;
                lastCanvas.height = 0;
                container.removeChild(lastCanvas);
                that.removeCount--;
                container.insertBefore(canvas, container.firstElementChild);
              }
              that.isRender = false;
              if (that.cleanTimer) {
                clearTimeout(that.cleanTimer);
                that.cleanTimer = undefined;
              }
              that.cleanTimer = setTimeout(() => {
                if (!that.isRender) {
                  container.scrollTop = container.scrollTop + (that.isUp ? 3 : -3); //渲染慢的时候，可能滚动停止，这里回滚3px
                  that.pdf.cleanup();
                  console.log("pdf.cleanup");
                }
                clearTimeout(that.cleanTimer);
                that.cleanTimer = undefined;
              }, 1500);
            },
            err => {
              alert(err); //渲染超时这个回调不执行
            }
          );
        });
      }
    },
    getPdf () {
      // 此中方式接受流形式返回
      let that = this;
      let container = document.getElementById(that.canvasId);
      if (!container) {
        return;
      }
      container.scrollTop = 0;
      let url = this.pdfurl;
      let CMAP_URL = "/pdfjs/cmaps/";
      // CMAP_URL = "/pdfjs/cmaps/";
      // let loadingTask = pdfjsLib.getDocument(url)
      let loadingTask = window.pdfjsLib.getDocument({
        url: url, // PDF base64编码
        cMapUrl: CMAP_URL,
        cMapPacked: true
      });
      loadingTask.promise.then(
        pdf => {
          that.pdf = pdf;
          that.numPages = pdf.numPages;
          if (that.numPages > 0) {
            that.nextShowPage = 1;
          }
          let container = document.getElementById(that.canvasId);
          that.pageNumber = 1;
          container && that.getPage(pdf, that.pageNumber, container, that.numPages);
          loadingTask = null;
        },
        function (reason) {
          that.$emit("pdferr", reason);
          this.$store.commit(this.$types.UPDATE_LOADING, false);
        }
      );
    },
    cleanCanvas () {
      document.getElementById(this.canvasId).innerHTML = "";
      this.pdf && this.pdf.cleanup();
      this.pdf = null;
      this.isInit = true;
    },
    destroyeview () {
      console.log("closepdfview");
      this.cleanCanvas();
    },
    closePdf () {
      this.$emit("closePdf");
    }
  },
  created () {},
  destroyed () {
    clearTimeout(this.renderTimer);
    clearTimeout(this.cleanTimer);
  }
};
</script>

<style scoped>
.vue-pdf-wrap {
  position: relative;
  padding: 0;
  overflow: hidden;
  position: fixed;
  background: #343434;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 80%;
  width: 100%;
  display: flex;
  flex-direction: column;
  width: 80%;
  margin: 2% 10% 0;
  height: auto;
  text-align: center;
  align-items: center;
}
.vue-pdf-wrap .pageInfo {
  display: block;
  width: 80%;
  position: fixed;
  top: 0;
  height: 50px;
  background: white;
  width: 100%;
  line-height: 50px;
}
.vue-pdf-wrap .pageInfo .pageCount {
  float: right;
  margin-right: 5px;
}
.vue-pdf-wrap .pageInfo .otherSpan {
  color: #333333;
  font-size: 14px;
}
.vue-pdf-wrap .pageInfo .fileName {
  font-weight: 600;
  font-size: 16px;
  color: #333333;
}
.vue-pdf-wrap .pageInfo .pageNumber {
  color: #db0808;
  font-weight: 600;
  font-size: 16px;
}
.vue-pdf-wrap .pdf-detail {
  margin: 0 auto;
  max-width: 100%;
  height: 100%;
  width: 100%;
  padding-bottom: 0.5rem;
  background: white;
}

.vue-pdf-wrap .pdf-canvas-wraper {
  height: 100%;
  background: #fff;
  width: 100%;
  box-sizing: border-box;
  background: #666;
  overflow-x: hidden;
}

.vue-pdf-wrap .pdf-canvas-wraper canvas {
  margin: 0 auto;
  display: block;
  margin-bottom: 10px;
  width: 100%;
}
.vue-pdf-wrap .pdfFooter {
  position: fixed;
  bottom: 0;
}
.vue-pdf-wrap .pdfFooter .closeBtn {
  width: 1rem;
  height: 0.36rem;
  line-height: 0.36rem;
  font-size: 14px;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
  margin-left: 0.32rem;
  background: #dcb369;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/vue-pdf.vue